(function () {
  function initCompare(el) {
    if (el.dataset.iwsCompareReady === 'true') return;
    el.dataset.iwsCompareReady = 'true';

    var media = el.querySelector('.iws-compare__media');
    if (!media) return;

    var dragging = false;
    var raf = null;
    var labelBefore = el.querySelector('.iws-compare__label--before');
    var labelAfter = el.querySelector('.iws-compare__label--after');

    function syncWidth() {
      var rect = media.getBoundingClientRect();
      if (rect.width > 0) {
        el.style.setProperty('--iws-cmp-box-width', rect.width + 'px');
      }
    }

    syncWidth();
    window.addEventListener('resize', syncWidth);
    if (window.ResizeObserver) {
      new ResizeObserver(syncWidth).observe(media);
    }
    // Remedir após carregamento das imagens
    el.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', syncWidth);
    });

    function updateLabels(percent) {
      // Rótulo da esquerda: some gradualmente conforme o slider se aproxima de 0%.
      // Começa a desaparecer nos últimos 25% do trajeto.
      if (labelBefore) {
        var leftOpacity = Math.max(0, Math.min(1, percent / 25));
        labelBefore.style.opacity = leftOpacity;
      }
      // Rótulo da direita: some gradualmente conforme o slider se aproxima de 100%.
      if (labelAfter) {
        var rightOpacity = Math.max(0, Math.min(1, (100 - percent) / 25));
        labelAfter.style.opacity = rightOpacity;
      }
    }

    function setPosition(percent) {
      var clamped = Math.max(0, Math.min(100, percent));
      el.style.setProperty('--iws-cmp-pos', clamped + '%');
      el.setAttribute('aria-valuenow', Math.round(clamped));
      updateLabels(clamped);
    }

    function percentFromClientX(clientX) {
      var rect = media.getBoundingClientRect();
      if (rect.width === 0) return 50;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function moveTo(clientX) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        setPosition(percentFromClientX(clientX));
        raf = null;
      });
    }

    // Pointer (cobre mouse, toque e caneta nos navegadores modernos)
    if (window.PointerEvent) {
      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        el.setPointerCapture(e.pointerId);
        moveTo(e.clientX);
      });
      el.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        moveTo(e.clientX);
      });
      el.addEventListener('pointerup', function () { dragging = false; });
      el.addEventListener('pointercancel', function () { dragging = false; });
    } else {
      // Fallback para navegadores antigos
      el.addEventListener('mousedown', function (e) { dragging = true; moveTo(e.clientX); });
      window.addEventListener('mousemove', function (e) { if (dragging) moveTo(e.clientX); });
      window.addEventListener('mouseup', function () { dragging = false; });
      el.addEventListener('touchstart', function (e) {
        dragging = true;
        moveTo(e.touches[0].clientX);
      }, { passive: true });
      el.addEventListener('touchmove', function (e) {
        if (dragging) moveTo(e.touches[0].clientX);
      }, { passive: true });
      el.addEventListener('touchend', function () { dragging = false; });
    }

    // Teclado (acessibilidade)
    el.addEventListener('keydown', function (e) {
      var current = parseFloat(el.getAttribute('aria-valuenow')) || 50;
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') {
        setPosition(current - step);
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        setPosition(current + step);
        e.preventDefault();
      } else if (e.key === 'Home') {
        setPosition(0);
        e.preventDefault();
      } else if (e.key === 'End') {
        setPosition(100);
        e.preventDefault();
      }
    });

    // Define o estado inicial dos rótulos conforme a posição de partida
    updateLabels(parseFloat(el.getAttribute('aria-valuenow')) || 50);
  }

  function initAll() {
    document.querySelectorAll('.iws-compare').forEach(initCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Reinicializar no editor de tema do Shopify
  document.addEventListener('shopify:section:load', initAll);
})();